// extracted by mini-css-extract-plugin
export default {"brandPromo":"YF-z","carousel":"ZF-z"};